module.exports = __webpack_public_path__ + "media/VR_demo.61c13aee.mp4";